import React from 'react';

import {
  Experiment,
  ExperimentControl,
  ExperimentVariant,
} from '@nerdwallet/features';

import classes from '@nerdwallet/base-styles/classes';
import { Box, Button, Link } from '@nerdwallet/currency';

import { EXPERIMENTS } from '.';

const TEST_NAME = EXPERIMENTS.frontPageDeEmphasizeCtaExperiment.id;
const { VARIANT } = EXPERIMENTS.frontPageDeEmphasizeCtaExperiment.variants;

type Props = {
  children: JSX.Element;
  primaryButtonText: string;
  primaryButtonUrl: string;
  primaryTrackInteraction: () => void;
  secondaryButtonText: string;
  secondaryButtonUrl: string;
  secondaryTrackInteraction: () => void;
};

const FrontPageDeEmphasizeSecondaryCtaExperiment = ({
  children,
  primaryButtonText,
  primaryButtonUrl,
  primaryTrackInteraction,
  secondaryButtonText,
  secondaryButtonUrl,
  secondaryTrackInteraction,
}: Props): JSX.Element => {
  return (
    <Experiment testName={TEST_NAME}>
      <ExperimentControl>{children}</ExperimentControl>
      <ExperimentVariant name={VARIANT}>
        <Box className={classes('text-align-center')}>
          <Box marginBottom={3}>
            <Button
              primary
              block
              href={primaryButtonUrl}
              onClick={primaryTrackInteraction}
            >
              {primaryButtonText}
            </Button>
          </Box>

          <Link href={secondaryButtonUrl} onClick={secondaryTrackInteraction}>
            {secondaryButtonText}
          </Link>
        </Box>
      </ExperimentVariant>
    </Experiment>
  );
};

export default FrontPageDeEmphasizeSecondaryCtaExperiment;
